import { Expose, Transform } from 'class-transformer';
import { Model } from './model';
import { getCookie } from 'src/app/shared/helper';
import { Constants } from '../../common';

export class UsersReportsReasonsModel extends Model {
  @Expose() block: boolean;
  @Expose() isDataRequired: boolean;
  @Expose() level: string;
  @Expose() type: string;
  @Expose({ name: '_id' }) id: string;
  @Expose()
  @Transform(({ value }) => (value ? value?.[getCookie(Constants.APP_LANGUAGE_COOKIE_KEY)] : null))
  translation: string;
}
